// This component displays the baseline results for a proposed Controlled
// Environment Agriculture (CEA) facility. It shows estimated impacts such as
// energy use, water use, and CO2 emissions, and provides options to download
// results or view decarbonization strategies.

import {getRandomInt, getTimestamp, numWithCommas, roundToSigFigs} from '../utils/utils'
import Accordion from 'react-bootstrap/Accordion';
import * as React from 'react';
import Button from "react-bootstrap/Button";
import {Badge} from "react-bootstrap";
import {CSVLink} from "react-csv";
import axios from "axios";
import {removeItemFromObject, applyPercentReductionsPerPathway}
    from "../utils/utils";

// Reference data for decarbonization pathways, including their expected
// reductions in energy, water, and emissions. Used to calculate the impact
// of each pathway on the baseline results.
const pathwaysRefData = [
    {
        "id": 1,
        "Pathway": "Low-Carbon Heat Generation",
        "Energy (% Reduction Min)": 0,
        "Energy (% Reduction Max)": 20,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 20,
        "Emissions (% Reduction Max)": 50
    },
    {
        "id": 2,
        "Pathway": "Low-Carbon Electricity Generation",
        "Energy (% Reduction Min)": null,
        "Energy (% Reduction Max)": null,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 50,
        "Emissions (% Reduction Max)": 50
    },
    {
        "id": 3,
        "Pathway": "Carbon-Free Heat Generation",
        "Energy (% Reduction Min)": null,
        "Energy (% Reduction Max)": null,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 100,
        "Emissions (% Reduction Max)": 100
    },
    {
        "id": 4,
        "Pathway": "Carbon-Free Electricity Generation",
        "Energy (% Reduction Min)": null,
        "Energy (% Reduction Max)": null,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 100,
        "Emissions (% Reduction Max)": 100
    },
    {
        "id": 5,
        "Pathway": "Strategic Energy Management",
        "Energy (% Reduction Min)": 3,
        "Energy (% Reduction Max)": 50,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 3,
        "Emissions (% Reduction Max)": 50
    },
    {
        "id": 6,
        "Pathway": "Colocation with Waste Heat Sources",
        "Energy (% Reduction Min)": 20,
        "Energy (% Reduction Max)": 30,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 60,
        "Emissions (% Reduction Max)": 60
    },
    {
        "id": 7,
        "Pathway": "Efficient Water Technologies",
        "Energy (% Reduction Min)": 3,
        "Energy (% Reduction Max)": 5,
        "Water (% Reduction Min)": 20,
        "Water (% Reduction Max)": 40,
        "Emissions (% Reduction Min)": 3,
        "Emissions (% Reduction Max)": 5
    },
    {
        "id": 8,
        "Pathway": "Efficient Lighting Solutions",
        "Energy (% Reduction Min)": 10,
        "Energy (% Reduction Max)": 55,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 10,
        "Emissions (% Reduction Max)": 55
    },
    {
        "id": 9,
        "Pathway": "Efficient HVAC Technologies",
        "Energy (% Reduction Min)": 12,
        "Energy (% Reduction Max)": 43,
        "Water (% Reduction Min)": null,
        "Water (% Reduction Max)": null,
        "Emissions (% Reduction Min)": 12,
        "Emissions (% Reduction Max)": 43
    },
    {
        "id": 10,
        "Pathway": "Advanced Controls",
        "Energy (% Reduction Min)": 15,
        "Energy (% Reduction Max)": 15,
        "Water (% Reduction Min)": 25,
        "Water (% Reduction Max)": 40,
        "Emissions (% Reduction Min)": 15,
        "Emissions (% Reduction Max)": 15
    }
]

// BaselineResultsControl is a React functional component that displays
// baseline impact metrics and provides controls for exporting results and
// exploring decarbonization strategies.
function BaselineResultsControl(props) {
    // The baselineResults object contains the calculated baseline metrics
    // for the selected facility or scenario.
    const baselineResults = props.baselineResults
    console.log('baseline here')
    console.log(props.baselineResults)
    // Prepare data for CSV export by removing the 'Location' property.
    const baselineResultsCsvData = [
        removeItemFromObject(baselineResults, 'Location')
    ]
    // Handler for the "Decarbonization Strategies" button. Applies the
    // reference pathway reductions to the baseline results and updates the
    // parent component's state to display the results.
    const handleDecarbStratBtnClick = () => {
        const pathwaysResults = applyPercentReductionsPerPathway(
            props.baselineResults, pathwaysRefData
        );
        props.pathwaysResultsSetter(pathwaysResults)
        props.pathwaysResultsVisibleSetter(true)
    }

    // Render the accordion UI containing the baseline results table and
    // action buttons.
    return (
        <Accordion
            defaultActiveKey="0"
            className="control-panel-accord baseline-results-control-accord"
            style={{
                position: 'absolute',
                // float: 'right',
                // clear:'left',
                // top: '8px',
                left: '650px',
                // width: '513px',
                // zIndex: 1000
            }}
        >
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    {/* The header for the accordion section. */}
                    <span className={'accord-title'}>
                            Baseline Operational Metrics</span>
                </Accordion.Header>
                <Accordion.Body className={'pt-2'} style={{
                    maxHeight: '250px',
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}>
                    <p style={{lineHeight: '15px'}}>
                        {/* Brief description of what the baseline results represent. */}
                        The estimated baseline impacts of the
                        proposed CEA facility:
                    </p>
                    <hr className={'mb-1'}/>
                    {/* Table displaying the main baseline metrics. */}
                    <table className="table table-striped"
                        // style={{fontSize: '10px'}}
                        // className={'mt-1'}
                    >
                        <thead>
                        <tr>
                            {/* Table headers for energy, water, and CO2. */}
                            <th className={'col-1'}>
                                Energy Use<br/>
                                <small
                                    style={{
                                        'fontWeight': 400, fontSize: '12px'
                                    }}>
                                    (MWh/year)
                                </small>
                            </th>
                            <th className={'col-1'}>
                                Water Use<br/>
                                <small
                                    style={{
                                        'fontWeight': 400, fontSize: '12px'
                                    }}>
                                    (L/year)
                                </small>
                            </th>
                            <th className={'col-1'}>
                                CO₂ Emissions <br/>
                                <small
                                    style={{
                                        'fontWeight': 400, fontSize: '12px'
                                    }}>
                                    (kg/year)
                                </small>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                                {/* Display the energy use, formatted with commas and significant figures. */}
                                <td>{baselineResults['Annual Energy Consumption (MWh/year)'] != null ? numWithCommas(
                                    roundToSigFigs(
                                        baselineResults[
                                            'Annual Energy Consumption (MWh/year)']
                                    )
                                ) : 'N/A'}
                                </td>
                            {/* Display the water use, formatted with commas and significant figures. */}
                            <td>{baselineResults['Annual Water Consumption (L/year)'] != null ? numWithCommas(
                                    roundToSigFigs(
                                        baselineResults['Annual Water Consumption (L/year)']
                                    )
                                ) : 'N/A'}
                                </td>
                            {/* Display the CO2 emissions, formatted with commas and significant figures. */}
                            <td>{baselineResults['CO2 emissions (kg/year)'] != null ? numWithCommas(
                                    roundToSigFigs(
                                        baselineResults[
                                            'CO2 emissions (kg/year)'
                                        ]
                                    ) // Closing parenthesis for numWithCommas moved inside
                                ) : 'N/A'}
                                </td>
                        </tr>
                        </tbody>
                    </table>
                    <div className={'d-flex justify-content-between'}>
                        {/* Button to download the baseline results as a CSV file. */}
                        <CSVLink data={baselineResultsCsvData}
                                 target="_blank"
                                 style={{width: '48%'}}
                                 filename={
                                    `cea_baseline_results_${getTimestamp()}.csv`
                                }
                        >
                            <Button variant="outline-secondary"
                                    className={'p-1'}
                                    style={{fontSize: '14px', width: '100%'}}
                            >
                                <p style={{lineHeight: '16px'}}
                                   className={'m-0'}>
                                    Download <br/> Results
                                </p>
                            </Button>
                        </CSVLink>
                        {/* Button to show decarbonization strategies based on the baseline. */}
                        <Button variant="outline-secondary"
                                className={'p-1'}
                                style={{fontSize: '14px', width: '48%'}}
                                onClick={() => handleDecarbStratBtnClick()}
                        >
                            <p style={{lineHeight: '16px'}} className={'m-0'}>
                                Efficiency Strategies
                            </p>
                        </Button>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

export default React.memo(BaselineResultsControl);
